import { render } from "./DataProviderSwitcher.vue?vue&type=template&id=4759377a&scoped=true"
import script from "./DataProviderSwitcher.vue?vue&type=script&lang=js"
export * from "./DataProviderSwitcher.vue?vue&type=script&lang=js"

import "./DataProviderSwitcher.vue?vue&type=style&index=0&id=4759377a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4759377a"]])

export default __exports__